import { EventEmitter, } from "@angular/core";
import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { PlatformLocation } from '@angular/common';
import { TokenService } from '../tokenService.service';
var CasePracticeListComponent = (function () {
    function CasePracticeListComponent(commonService, platformLocation, apiService, route, tokenService, router) {
        this.commonService = commonService;
        this.platformLocation = platformLocation;
        this.apiService = apiService;
        this.route = route;
        this.tokenService = tokenService;
        this.router = router;
        this.onGoToExercise = new EventEmitter();
        this.isOpenClass = 0;
        //进入新能力考核标识
        this.version = 0;
        //学习 metaId
        this.learningPathMetaId = 0;
        this.isShowQuestionnaire = false;
        this.questionnaireInfo = null;
        this.approachTheme = {};
        this.currentIndex = 0;
        this.isShowApproach = false;
        this.isCustomLock = false;
        this.lock = false;
        this.isShowToast = false;
        this.isTencent = false; // 是否腾讯对接
        this.isHarmonyOS = false; // 是否鸿蒙系统
    }
    Object.defineProperty(CasePracticeListComponent.prototype, "showGoToSurveyBtn", {
        get: function () {
            return this.practiceList.every(function (item) {
                return item.status === 2;
            });
        },
        enumerable: true,
        configurable: true
    });
    CasePracticeListComponent.prototype.ngOnInit = function () {
        var _this = this;
        // ---Stephen add 2025-03-07---
        // 添加是否腾讯对接的判断
        this.isTencent = this.commonService.checkAndSetModuleId();
        console.log(this.isTencent, '🐒🐒🐒🐒🐒🐒');
        // -------------------------------------------------------------------
        this.isHarmonyOS = this.commonService.isHarmonyOS();
        console.log(this.practiceMetaId, '_____________________________');
        this.isOpenClass = Number(localStorage.getItem("openClass")) ? 1 : 0;
        localStorage.setItem("moduleId", "3");
        this.route.queryParams.subscribe(function (queryParams) {
            _this.type = queryParams['type'];
        });
        //特殊场景处理
        this.IsSpecial = false;
        if (this.practiceList.length == 2) {
            if (this.practiceList[0].title == "报告迟交，谁之过?") {
                this.IsSpecial = false;
            }
        }
        this.projectId = localStorage.getItem("projectId");
        var projectmsg = JSON.parse(localStorage.getItem('projectmsg'));
        if (this.projectId && projectmsg) {
            projectmsg.map(function (item) {
                if (item.type == 4 && item.lockType == 1) {
                    _this.lock = item.lock;
                    _this.promptText = "\u80FD\u529B\u8003\u6838\u5C06\u4E8E" + item.promptTime + "\u5F00\u653E\u3002";
                }
            });
        }
        this.practiceListInit();
    };
    //初始化情景模拟列表
    CasePracticeListComponent.prototype.practiceListInit = function () {
        var _this = this;
        this.getLearningTour().then(function (result) {
            _this.userId = result.user_id;
            $('#userIdContainer').val(_this.userId);
            _this.learningPathMetas = result.learning_path_metas;
        }).then(function () {
            return _this.getLearningPathMetaId(_this.learningPathId).then(function (result) {
                console.log(result);
                $('#learningPathMetaIdContainer').val(result.data);
                return _this.learningPathMetaId = result.data;
            });
        }).then(function () {
            return _this.getPracticeComment(_this.learningPathId, { learningPathId: _this.learningPathId }).then(function (result) {
                return _this.chuanjie = result.length >= 4 ? result[2].comment : '';
            });
        }).then(function () {
            return _this.commonService.getOnceIno(_this.commonService.getOnceValue(_this.learningPathMetaId, 2)).then(function (result) {
                return _this.finishStatus = result == 1;
            });
        }).then(function () {
            return _this.getOrCreateLearningPath(String(_this.learningPathMetaId)).then(function (result) {
                return _this.learningPath = result;
            });
        }).then(function () {
            return _this.getProgress(_this.learningPathMetaId).then(function (result) {
                //向LMS传递进度
                if (localStorage.getItem("source_env") === "LMS_SCORM") {
                    _this.commonService.sendDataMessage('type', 'LMS_LEARN_PROGRESS', result[0].progressList[0].progress, "data");
                }
                return _this.currentIndex = result[0]['progressList'][0]['currentItemIndex'] == 4 && result[0]['progressList'][0]['progress'] == 100 ? 5 : result[0]['progressList'][0]['currentItemIndex'];
            });
        }).then(function () {
            return _this.getUserQuestionnaireInfo(_this.learningPathMetaId).then(function (result) {
                return _this.questionnaireInfo = result;
            });
        }).then(function () {
            var temp = true;
            _this.commonService.setCustomLockDate(_this.learningPath, Date());
            _this.learningPathSubItems = _this.learningPath.subItems;
            for (var i = 0; i <= _this.practiceList.length - 1; i++) {
                if (_this.practiceList[i].status != 2) {
                    temp = false;
                }
            }
            _this.finished = temp;
            setTimeout(function () {
                if (_this.finished) {
                    //新能力考核 version == 1 时,有能力考核,出现考核按钮,完成按钮不出现
                    if (_this.version == 1) {
                        $("#surveyBtn").fadeIn(200);
                    }
                    else {
                        $("#nextWrap").show().animate({ bottom: 0 });
                    }
                }
            }, 1000);
        }).then(function () {
            _this.approachTheme.colorSystem = 'dark';
            _this.approachTheme.label = ['能力诊断', '课程学习', '情景模拟', '能力考核'];
            _this.approachTheme.currentIndex = _this.currentIndex - 2;
            _this.approachTheme.desc = '离完成只差最后一步了，交出你优秀的答卷吧！';
            _this.approachTheme.btnTxt = '开启能力考核';
            _this.isShowQuestionnaire = _this.questionnaireInfo && _this.questionnaireInfo.length === 0 && _this.learningPathSubItems.length === 4 && _this.learningPathSubItems.filter(function (d) { return d.type === 3; })[0].progress === 100 && _this.learningPathSubItems.filter(function (d) { return d.type === 4; })[0].progress !== 100;
        }).then(function () {
            _this.commonService.addUserBreakPoint({ 'learningPathMetasId': Number(_this.learningPathMetaId), 'moduleId': 3, 'breakpointUrl': _this.platformLocation['location']['href'], 'projectId': localStorage.getItem("projectId") ? localStorage.getItem("projectId") : null }).then();
            _this.isCustomLock = _this.learningPathSubItems.length === 4 && _this.learningPathSubItems[3].isLock ? _this.learningPathSubItems : false;
            _this.isShowApproach = true;
        });
    };
    //获取进度
    CasePracticeListComponent.prototype.getProgress = function (learningPathMetaId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/user/learning/progress?learningPathMetaIds=' + String(learningPathMetaId),
        }).toPromise();
    };
    //获取learningPath
    CasePracticeListComponent.prototype.getOrCreateLearningPath = function (learningPathMetaId) {
        return this.apiService.getOrCreateLearningPath(learningPathMetaId).toPromise();
    };
    CasePracticeListComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage({
            backgroundColor: "white",
        });
    };
    //获取传接
    CasePracticeListComponent.prototype.getPracticeComment = function (learningPathId, data) {
        return this.apiService.ajax({
            type: "get",
            url: "/api/concatenation/" + learningPathId,
            data: data
        }).toPromise();
    };
    //获取learningTour
    CasePracticeListComponent.prototype.getLearningTour = function () {
        return this.apiService.ajax({
            type: "get",
            url: "/sr/learningtournew",
        }).toPromise();
    };
    //获取learningPathMetaId
    CasePracticeListComponent.prototype.getLearningPathMetaId = function (learningPathId) {
        return this.apiService.ajax({
            'type': 'get',
            'url': '/ddilearner/v1/getLearningPathMetaId/' + learningPathId
        }).toPromise();
    };
    //查询用户相应能力满意度
    CasePracticeListComponent.prototype.getUserQuestionnaireInfo = function (learningPathMetaId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v1/usersSatisficing/learningPathMetaId/' + learningPathMetaId
        }).toPromise();
    };
    CasePracticeListComponent.prototype.close = function () {
        var _this = this;
        // 只在learningTour里出现，当完成能力是退出进入map
        if ((this.finishStatus || !this.finished) && this.learningTour) {
            var link = ["learning-map", 3];
            this.router.navigate(link);
        }
        else if (!this.finishStatus && this.finished && this.learningTour) {
            this.commonService.setOnceIno(this.commonService.getOnceValue(this.learningPathMetaId, 2)).subscribe(function () {
                _this.router.navigate(["learning-map", 3]);
            });
        }
        else {
            var learningPathId_1 = null;
            var courseId_1 = null;
            this.route.queryParams.subscribe(function (queryParams) {
                learningPathId_1 = queryParams['learningPathId'];
                courseId_1 = queryParams['courseId'];
            });
            if (learningPathId_1 && courseId_1) {
                var link = ['course-new', learningPathId_1, courseId_1];
                this.router.navigate(link);
            }
            else {
                var link = ["learning-path", this.learningPathMetaId];
                this.router.navigate(link);
            }
        }
    };
    CasePracticeListComponent.prototype.goToNextStep = function (i) {
        var _this = this;
        console.log(i);
        $('#exerciseMetaId').val(this.practiceList[i].exerciseMetaId);
        // this.commonService.learningPortEventLogByCandy({'learningPathMetaId':this.learningPathMetaId,'module':'进入情景模拟'+(i+1)}).then();
        localStorage.setItem('exerciseMetaId', this.practiceList[i].exerciseMetaId);
        if (this.status == 1 || (this.status != 1 && i == 0)) {
            if (this.practiceList[i].status != 2) {
                if (i == 2) {
                    var channel = document.getElementById('resource_route');
                    var origin = channel.dataset.src === '' ? this.commonService.getOrigin() : 'https://m.transtalent.cn';
                    var params = channel.dataset.src === '' ? '' : '&channelHost=' + this.commonService.getOrigin() + '/yyddi/';
                    var originUrl = origin + '/coach/60503/index.html?userId=' + this.userId + '&learningPathMetaId=' + this.learningPathMetaId + '&simulationId=60503&learningPathId=' + this.learningPathId + '&practiceMetaId=' + this.practiceMetaId + '&token=' + this.tokenService.findToken() + '&userIdEncoder=' + this.tokenService.findUserIdEncoder();
                    this.platformLocation['location']['href'] = this.isOpenClass === 1 ? originUrl + '&isShowBack=0' : this.type === 'huatek' ? originUrl + '&type=huatek' : originUrl + params;
                }
                else {
                    this.onGoToExercise.emit(i);
                }
            }
            else {
                if (i == 2) {
                    this.getCardIdWithUserId(60503, this.userId).then(function (result) {
                        if (_this.type) {
                            _this.router.navigate(['egret-practice-coach-report', 60503, result.id], { queryParams: { type: 'huatek' } });
                        }
                        else {
                            _this.router.navigate(['egret-practice-coach-report', 60503, result.id]);
                        }
                    });
                }
                else {
                    var link = [
                        "case-practice-report-new",
                        this.practiceId,
                        this.practiceList[i].id,
                        this.learningPathId,
                    ];
                    if (this.type) {
                        this.router.navigate(link, { queryParams: { type: 'huatek' } });
                    }
                    else {
                        this.router.navigate(link);
                    }
                }
            }
        }
        else {
            $("#mengban").fadeIn();
        }
    };
    CasePracticeListComponent.prototype.goToPostSurvey = function () {
        if (this.type === 'huatek') {
            this.commonService.sendPostMessage(1, 'goPostSurvey');
            return;
        }
        else {
            if (this.lock) {
                this.showToast();
                return;
            }
            this.commonService.learningPortEventLogByCandy({ 'learningPathMetaId': this.learningPathMetaId, 'module': '情景模拟', 'btnName': this.approachTheme.btnTxt, 'userId': localStorage.getItem("userId") }).then();
            this.apiService
                .ajax({
                type: "GET",
                url: "/sr/exposeoutapi/setAbilitySession/" +
                    this.learningPathMetaId +
                    "/4",
            })
                .subscribe(function (result) { });
            var link = ["ability-survey", this.learningPathMetaId, 2];
            // let link = ["survey", this.learningPathId, 3, 1];
            // //新能力考核
            // if (this.version == 1) {
            //   link = ["ability-survey", this.learningPathMetaId, 2];
            // }
            this.router.navigate(link);
        }
    };
    CasePracticeListComponent.prototype.showToast = function () {
        var _this = this;
        this.isShowToast = true;
        setTimeout(function () {
            _this.isShowToast = false;
        }, 2000);
    };
    CasePracticeListComponent.prototype.finish = function () {
        if (this.finishStatus) {
            return;
        }
        else {
            this.commonService.setOnceIno(this.commonService.getOnceValue(this.learningPathMetaId, 2)).subscribe();
            var link = ["learning-map"];
            this.router.navigate(link);
        }
    };
    CasePracticeListComponent.prototype.shiyong = function () {
        var link = ["form", "3"];
        this.router.navigate(link);
    };
    CasePracticeListComponent.prototype.closeTip = function () {
        $("#mengban").fadeOut();
    };
    CasePracticeListComponent.prototype.getCardIdWithUserId = function (exerciseMetaId, userId) {
        return this.apiService.ajax({
            'type': 'GET',
            // 'url': this.commonService.getOrigin() + '/sim/v1/simulation/' + exerciseMetaId + '/currentCard?userId=' + userId
            'url': '/sim/v1/simulation/' + exerciseMetaId + '/currentCard'
        }).toPromise();
    };
    CasePracticeListComponent.prototype.closeQuestionnaire = function () {
        this.isShowQuestionnaire = false;
    };
    return CasePracticeListComponent;
}());
export { CasePracticeListComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-list/case-practice-list.component.ts.pre-build-optimizer.js